import Vue from 'vue'
import Router from 'vue-router'
import PageTest from '@/components/Page/PageTest'
import helper from "@/components/Utility/Helper"

Vue.use(Router)

// {
//   path: '/dashboard',
//   name: 'userboard',
//   component: UserBoard,
//   meta: { 
//       requiresAuth: true
//   }
// },

// create route in sidebar
function createRoute(path, name, ...args) {
  var temp = {};
  temp.path = path;
  temp.name = name;
  temp.show = true;

  for(let argument of args) {
    if(argument instanceof Array) {
      temp.child = argument;
    } else if(typeof argument === 'boolean') {
      temp.show = argument;
    } else if(typeof argument === 'string') {
      temp.icon = argument;
    } else if(argument instanceof Promise) {
      temp.component = () => argument;
    } else if(argument instanceof Object) {
      if(argument.render) {
        temp.component = argument;
      } else {
        temp.parameter = argument;
      }
    }
  }
  return temp;
}

import PageDashboard from '@/components/Page/PageDashboard'
import PageLanding from '@/components/Page/PageLanding'
import PageCity from '@/components/Page/PageCity'

import PageEntitlement from '@/components/Page/CarPark/PageEntitlement'
import PageCarPark from '@/components/Page/CarPark/PageCarPark'
import PageCarParkForm from '@/components/Page/CarPark/PageCarParkForm'
import PageLevel from '@/components/Page/CarPark/PageLevel'
import PageZone from '@/components/Page/CarPark/PageZone'
import PageZoneLevel from '@/components/Page/CarPark/PageZoneLevel'
import PageStreet from '@/components/Page/CarPark/PageStreet'
import PageStreetBay from '@/components/Page/CarPark/PageStreetBay'
import PageTenant from '@/components/Page/CarPark/PageTenant'
import PageProduct from '@/components/Page/CarPark/PageProduct'
import PageProductForm from '@/components/Page/CarPark/PageProductForm'
import PageProductFees from '@/components/Page/CarPark/PageProductFees'
import PageProductFeesChange from '@/components/Page/CarPark/PageProductFeesChange'

import PageCompany from '@/components/Page/ParkingLicense/PageCompany'
import PageCompanyForm from '@/components/Page/ParkingLicense/PageCompanyForm'
import PageCompanyParker from '@/components/Page/ParkingLicense/PageCompanyParker'
import PagePersonal from '@/components/Page/ParkingLicense/PagePersonal'
import PagePersonalForm from '@/components/Page/ParkingLicense/PagePersonalForm'
import PagePersonalParker from '@/components/Page/ParkingLicense/PagePersonalParker'
import PagePLCarpark from '@/components/Page/ParkingLicense/PagePLCarpark'
import PagePLLease from '@/components/Page/ParkingLicense/PagePLLease'
import PagePLLeaseParkAide from '@/components/Page/ParkingLicense/PagePLLeaseParkAide'
import PagePLView from '@/components/Page/ParkingLicense/PagePLView'
import PagePLApplication from '@/components/Page/ParkingLicense/PagePLApplication'
import PagePLApplicationPending from '@/components/Page/ParkingLicense/PagePLApplicationPending'
import PagePLApplicationForm from '@/components/Page/ParkingLicense/PagePLApplicationForm'
import PagePLApplicationForm2 from '@/components/Page/ParkingLicense/PagePLApplicationForm2'
import PagePLTermination from '@/components/Page/ParkingLicense/PagePLTermination'
import PagePLTerminationForm from '@/components/Page/ParkingLicense/PagePLTerminationForm'
import PagePLProductChange from '@/components/Page/ParkingLicense/PagePLProductChange'
import PagePLProductChangeForm from '@/components/Page/ParkingLicense/PagePLProductChangeForm'
import PagePLReinstatement from '@/components/Page/ParkingLicense/PagePLReinstatement'
import PagePLReinstatementForm from '@/components/Page/ParkingLicense/PagePLReinstatementForm'
import PagePLAddOn from '@/components/Page/ParkingLicense/PagePLAddOn'
import PagePLAddOnPending from '@/components/Page/ParkingLicense/PagePLAddOnPending'
import PagePLAddOnForm from '@/components/Page/ParkingLicense/PagePLAddOnForm'
import PagePLAddOnForm2 from '@/components/Page/ParkingLicense/PagePLAddOnForm2'
import PagePLPaymentPlanChange from '@/components/Page/ParkingLicense/PagePLPaymentPlanChange'
import PagePLPaymentPlanChangeForm from '@/components/Page/ParkingLicense/PagePLPaymentPlanChangeForm'
import PagePLReactivation from '@/components/Page/ParkingLicense/PagePLReactivation'
import PagePLReactivationForm from '@/components/Page/ParkingLicense/PagePLReactivationForm'

import PagePasscardType from '@/components/Page/Passcard/PagePasscardType'
import PagePasscard from '@/components/Page/Passcard/PagePasscard'
import PagePasscardIssue from '@/components/Page/Passcard/PagePasscardIssue'
import PagePasscardIssuePriority from '@/components/Page/Passcard/PagePasscardIssuePriority'
import PagePasscardLetter from '@/components/Page/Passcard/PagePasscardLetter'
import PagePasscardTermination from '@/components/Page/Passcard/PagePasscardTermination'
import PagePasscardTerminationApplication from '@/components/Page/Passcard/PagePasscardTerminationApplication'
import PagePasscardTerminationForm from '@/components/Page/Passcard/PagePasscardTerminationForm'
import PagePasscardTerminationApplicationView from '@/components/Page/Passcard/PagePasscard_TerminationApplicationView'
import PagePasscardTerminationApplicationPrint from '@/components/Page/Passcard/PagePasscard_TerminationApplicationPrint'
import PagePasscardLostDamageFaulty from '@/components/Page/Passcard/PagePasscardLostDamageFaulty'
import PagePasscardLostDamageFaultyApplication from '@/components/Page/Passcard/PagePasscardLostDamageFaultyApplication'
import PagePasscardLostDamageFaultyForm from '@/components/Page/Passcard/PagePasscardLostDamageFaultyForm'
import PagePasscardLostAndFound from '@/components/Page/Passcard/PagePasscardLostAndFound'
import PagePasscardLostAndFoundApplication from '@/components/Page/Passcard/PagePasscardLostAndFoundApplication'
import PagePasscardLostAndFoundForm from '@/components/Page/Passcard/PagePasscardLostAndFoundForm'
import PagePasscardToParkAide from '@/components/Page/Passcard/PagePasscardToParkAide'
import PagePasscardToParkAideApplication from '@/components/Page/Passcard/PagePasscardToParkAideApplication'
import PagePasscardToParkAideForm from '@/components/Page/Passcard/PagePasscardToParkAideForm'
import PagePasscardFromParkaide from '@/components/Page/Passcard/PagePasscardFromParkaide'
import PagePasscardFromParkaideApplication from '@/components/Page/Passcard/PagePasscardFromParkaideApplication'
import PagePasscardFromParkaideForm from '@/components/Page/Passcard/PagePasscardFromParkaideForm'
import PagePasscardBlock from '@/components/Page/Passcard/PagePasscardBlock'
import PagePasscardUnblock from '@/components/Page/Passcard/PagePasscardUnblock'
import PagePasscardBlockTermination from '@/components/Page/Passcard/PagePasscardBlockTermination'
import PagePasscardBlockDamageFaulty from '@/components/Page/Passcard/PagePasscardBlockDamageFaulty'
import PagePasscardBlockLostAndFound from '@/components/Page/Passcard/PagePasscardBlockLostAndFound'
import PagePasscardBlockToParkAide from '@/components/Page/Passcard/PagePasscardBlockToParkAide'
import PagePasscardUnblockLostAndFound from '@/components/Page/Passcard/PagePasscardUnblockLostAndFound'
import PagePasscardReturnTermination from '@/components/Page/Passcard/PagePasscardReturnTermination'
import PagePasscardReturnDamageFaulty from '@/components/Page/Passcard/PagePasscardReturnDamageFaulty'
import PagePasscardReturnLostAndFound from '@/components/Page/Passcard/PagePasscardReturnLostAndFound'
import PagePasscardReturnToParkAide from '@/components/Page/Passcard/PagePasscardReturnToParkAide'

import PageBillCollection from '@/components/Page/Collection/PageBillCollection'
import PageBillCollectionForce from '@/components/Page/Collection/PageBillCollectionForce'
import PageBillCollectionSplit from '@/components/Page/Collection/PageBillCollectionSplit'
import PageTagDepositCheque from '@/components/Page/Collection/PageTagDepositCheque'
import PageTagDepositCash from '@/components/Page/Collection/PageTagDepositCash'
import PageTagDepositPPS from '@/components/Page/Collection/PageTagDepositPPS'
import PagePaymentHistory from '@/components/Page/Collection/PagePaymentHistory'
import PageOfficialReceipt from '@/components/Page/Collection/PageOfficialReceipt'
import PagePaymentDetail from '@/components/Page/Collection/PagePaymentDetail'
import PageBillPayment from '@/components/Page/Collection/PageBillPayment'
import PageBillIpay88 from '@/components/Page/Collection/PageBillIpay88'
import PageBillIpay88_2 from '@/components/Page/Collection/PageBillIpay88_2'
import PageBillIpay88_3 from '@/components/Page/Collection/PageBillIpay88_3'
import PageOR from '@/components/Page/Collection/PageOR'

import PageRefundList from '@/components/Page/Refund/PageRefundList'
import PageRefundVoucher from '@/components/Page/Refund/PageRefundVoucher'
import PageRefundAll from '@/components/Page/Refund/PageRefundAll'
import PagePaymentVoucher from '@/components/Page/Refund/PagePaymentVoucher'
import PageRefundGenerateGiroFile from '@/components/Page/Refund/PageRefundGenerateGiroFile'
import PagePV from '@/components/Page/Refund/PagePV'

import PageBillAccountSummary from '@/components/Page/BillManagement/PageBillAccountSummary'
import PageBillInvoice from '@/components/Page/BillManagement/PageBillInvoice'
import PageBillCN from '@/components/Page/BillManagement/PageBillCN'
import PageBillDN from '@/components/Page/BillManagement/PageBillDN'
import PageBill from '@/components/Page/BillManagement/PageBill'
import PageStopBillRecord from '@/components/Page/BillManagement/PageStopBillRecord'
import PageReverseStopBill from '@/components/Page/BillManagement/PageReverseStopBill'
import PageReverseStopBillForm from '@/components/Page/BillManagement/PageReverseStopBillForm'
import PageEInvoiceSetting from '@/components/Page/BillManagement/PageEInvoiceSetting'
import PageConsolidatedBill from '@/components/Page/BillManagement/PageConsolidatedBill'
import PageEInvoiceDocument from '@/components/Page/BillManagement/PageEInvoiceDocument'

import PageReportCustomerFees from '@/components/Page/Report/PageReportCustomerFees'
import PageReportCustomerMovement from '@/components/Page/Report/PageReportCustomerMovement'
import PageReportCarparkProduct from '@/components/Page/Report/PageReportCarparkProduct'
import PageReportBill from '@/components/Page/Report/PageReportBill'
import PageReportCustomerCompany from '@/components/Page/Report/PageReportCustomerCompany'
import PageReportCustomerPersonal from '@/components/Page/Report/PageReportCustomerPersonal'
import PageReportCarParkCollection from '@/components/Page/Report/PageReportCarParkCollection'
import PageReportCarParkSST from '@/components/Page/Report/PageReportCarParkSST'
import PageReportRemittance from '@/components/Page/Report/PageReportRemittance'
import PageReportOutstanding from '@/components/Page/Report/PageReportOutstanding'
import PageReportInvoice from '@/components/Page/Report/PageReportInvoice'
import PageReportProfilePersonal from '@/components/Page/Report/PageReportProfilePersonal'
import PageReportProfileCompany from '@/components/Page/Report/PageReportProfileCompany'
import PagePLLeaseReport from '@/components/Page/ParkingLicense/PagePLLeaseReport'
import PageReportLPR from '@/components/Page/Report/PageReportLPR'

import PageStaff from '@/components/Page/Admin/PageStaff'
import PageInternalUser from '@/components/Page/Admin/PageInternalUser'
import PageRole from '@/components/Page/Admin/PageRole'
import PageRoleForm from '@/components/Page/Admin/PageRoleForm'
import PageUserRole from '@/components/Page/Admin/PageUserRole'
import PageSetting from '@/components/Page/Admin/PageSetting'
import PageRegistrationTnC from '@/components/Page/Admin/PageRegistrationTnC'
import PageRegistrationPP from '@/components/Page/Admin/PageRegistrationPP'
import PageTerminationTnC from '@/components/Page/Admin/PageTerminationTnC'
import PageSystemActivityDate from '@/components/Page/Admin/PageSystemActivityDate'
import PageViewTnC from '@/components/Page/Admin/PageViewTnC'
import PageViewPP from '@/components/Page/Admin/PageViewPP'
import PageViewSeasonTerminationTnC from '@/components/Page/Admin/PageViewSeasonTerminationTnC'

import PageManualBillLicense from '@/components/Page/Manual/PageManualBillLicense'
import PageManualBillCarpark from '@/components/Page/Manual/PageManualBillCarpark'
import PageManualRateLicense from '@/components/Page/Manual/PageManualRateLicense'
import PageManualParkaide from '@/components/Page/Manual/PageManualParkaide'
import PageManualParkaide2 from '@/components/Page/Manual/PageManualParkaide2'
import PageManualSnatch from '@/components/Page/Manual/PageManualSnatch'
import PageManualLatePayment from '@/components/Page/Manual/PageManualLatePayment'
import PageManualLatePaymentReverse from '@/components/Page/Manual/PageManualLatePaymentReverse'
import PageManualStopBillEmail from '@/components/Page/Manual/PageManualStopBillEmail'
import PageManualStopBill from '@/components/Page/Manual/PageManualStopBill'
import PageManualReactivate from '@/components/Page/Manual/PageManualReactivate'
import PageManualProductChange from '@/components/Page/Manual/PageManualProductChange'
import PageManualTerminate from '@/components/Page/Manual/PageManualTerminate'
import PageManualTerminate14 from '@/components/Page/Manual/PageManualTerminate14'



import PageLogout from '@/components/Page/User/PageLogout'
import PageLogin from '@/components/Page/User/PageLogin'
import PageRegister from '@/components/Page/User/PageRegister'
import PageVerify from '@/components/Page/User/PageVerify'
import PageForgotPassword from '@/components/Page/User/PageForgotPassword'
import PageChangePassword from '@/components/Page/User/PageChangePassword'
import PageRedirect from '@/components/Page/User/PageRedirect'
import PageNoProfile from '@/components/Page/User/PageNoProfile'
import PageTnc from '@/components/Page/User/PageTnC'
import PagePrivacyPolicy from '@/components/Page/User/PagePrivacyPolicy'
import PageChooseAccount from '@/components/Page/User/PageChooseAccount'
import PageCreateProfile from '@/components/Page/User/PageCreateProfile'
import PageAccount from '@/components/Page/User/PageAccount'


const routeAll = [
  createRoute('/', 'Landing2', false, PageLanding),
  createRoute('/landing', 'Landing', false, PageLanding),
  createRoute('/dashboard', 'Dashboard', 'fa fa-th-large', PageDashboard, {permission: 'dashboard', permission_action: [{permission: '.view', action: 'View '}] }),
  // createRoute('/city', 'City', 'fa fa-building', PageCity),
  createRoute('', 'Car Park', 'fa fa-car', [
      createRoute('/entitlement', 'Entitlement', PageEntitlement, {permission: 'entitlement', permission_action: 2}),
      createRoute('/carpark', 'Car Park', PageCarPark, {permission: 'carpark', permission_action: [{permission: '.view', action: 'View '}, {permission: '.add', action: 'Add '}, {permission: '.edit', action: 'Edit '}, {permission: '.remove', action: 'Remove '}, {permission: '.cpid', action: 'View Snatch Car Park ID'}, {permission: '.cpid_edit', action: 'Edit Snatch Car Park ID'}]}),
      // createRoute('/level', 'Car Park Level', PageLevel, {permission: 'carpark_level'}),
      createRoute('', 'Car Park Zone', [
        createRoute('/zone', 'Zone', PageZone, {permission: 'carpark_zone'}),
        // createRoute('/zlevel', 'Zone Level', PageZoneLevel, {permission: 'carpark_zlevel'}),
        createRoute('/street', 'Street', PageStreet, {permission: 'carpark_street'}),
        createRoute('/bay', 'Bay', PageStreetBay, {permission: 'carpark_bay', permission_action: 4}),
      ]),
      createRoute('/product', 'Car Park Product', PageProduct, {permission: 'product', permission_action: 2}),
      createRoute('/productFees', 'Product Fees', false, PageProductFees, {permission: 'productfee', permission_action: [{permission: '.view', action: 'View '}, {permission: '.add', action: 'Add '}, {permission: '.activate', action: 'Activate '}, {permission: '.remove', action: 'Remove '}]}),
      createRoute('/tenant', 'Car Park Tenant', PageTenant, {permission: 'tenant'}),

      createRoute('/carparkForm', 'Car Park Form', false, PageCarParkForm, {permission: 'carpark'}),
      createRoute('/productForm', 'Product Form', false, PageProductForm, {permission: 'product'}),
    ]
  ),
  
  createRoute('', 'Parking License', 'fa fa-id-card-o', [
      createRoute('', 'Customer List', [
        // // messed up sidebar
        // createRoute('/company', 'Company', PageCustomer),
        // createRoute('/personal', 'Personal', PageCustomer),
        createRoute('/company', 'Company', PageCompany, {permission: 'company'}),
        createRoute('/personal', 'Personal', PagePersonal, {permission: 'personal'}),
      ]),
      createRoute('/companyForm', 'Company Form', false, PageCompanyForm, {permission: 'company'}),
      createRoute('/companyParker', 'Company Parker', false, PageCompanyParker, {permission: 'company_parker', permission_action: 4}),
      createRoute('/personalForm', 'Personal Form', false, PagePersonalForm, {permission: 'personal'}),
      createRoute('/personalParker', 'Personal Parker', false, PagePersonalParker, {permission: 'personal_parker', permission_action: 4}),
      
      createRoute('', 'Parking License', [
        createRoute('/parkinglicense', 'Parking License', PagePLCarpark, {permission: 'parkinglicense', permission_action: 3}),
        createRoute('/plLease', 'Parking License<br>Subscription', PagePLLease, {permission: 'parkinglicense_lease', permission_action: 3}),
        createRoute('/plParkAideLease', 'ParkAide<br>Subscription', PagePLLeaseParkAide, {permission: 'parkinglicense_lease', permission_action: 3}),
        // createRoute('/plCustomer', 'PL by Account Holder', PagePLCustomer),
        // createRoute('/plLease', 'Subscription by Account Holder', PagePLLease),
      ]),
      createRoute('', 'Application', [
        createRoute('/plApplication', 'Parking License<br>Application', PagePLApplication, {permission: 'parkinglicense_application', permission_action: [{permission: '.view', action: 'View '}, {permission: '.add', action: 'Add '}, {permission: '.edit', action: 'Update '}, {permission: '.approve', action: 'Approve '}, {permission: '.reject', action: 'Reject '}, {permission: '.void', action: 'VOID '}]}),
        createRoute('/plAddOn', 'Parking License<br>Add On', PagePLAddOn, {permission: 'parkinglicense_addon', permission_action: [{permission: '.view', action: 'View '}, {permission: '.add', action: 'Add '}, {permission: '.edit', action: 'Update '}, {permission: '.approve', action: 'Approve '}, {permission: '.reject', action: 'Reject '}, {permission: '.void', action: 'VOID '}]}),
        createRoute('/plTermination', 'Termination Application', PagePLTermination, {permission: 'parkinglicense_termination', permission_action: 2}),
        createRoute('/plTerminationPending', 'Pending Termination Application ', PagePLTermination, {permission: 'parkinglicense_termination', permission_action: 2}),
        createRoute('/plProductChange', 'Product Change<br>Application', PagePLProductChange, {permission: 'parkinglicense_pc', permission_action: [{permission: '.view', action: 'View '}, {permission: '.add', action: 'Add '}, {permission: '.edit', action: 'Update '}, {permission: '.approve', action: 'Approve '}, {permission: '.reject', action: 'Reject '}, {permission: '.void', action: 'VOID '}]}),
        createRoute('/plPaymentPlanChange', 'Payment Plan<br>Change Application', PagePLPaymentPlanChange, {permission: 'parkinglicense_ppc', permission_action: 2}),
        createRoute('/plReinstatement', 'Reinstatement<br>Application', PagePLReinstatement, {permission: 'parkinglicense_reinstatement', permission_action: 2}),
        createRoute('/plReactivation', 'Reactivation<br>Application', PagePLReactivation, {permission: 'parkinglicense_reactivation', permission_action: 2}),
      ]),
      createRoute('', 'Pending Approval', [
        createRoute('/plApplicationPending', 'Parking License<br>Application ', PagePLApplicationPending, {permission: 'parkinglicense_application_pending', permission_action: 3}),
        createRoute('/plAddOnPending', 'Parking License<br>Add On ', PagePLAddOnPending, {permission: 'parkinglicense_addon_pending', permission_action: 3}),
        createRoute('/plProductChangePending', 'Product Change<br>Application ', PagePLProductChange, {permission: 'parkinglicense_pc_pending', permission_action: 3}),
        // createRoute('/plPaymentPlanChangePending', 'Payment Plan<br>Change Application ', PagePLPaymentPlanChange, {permission: 'parkinglicense_ppc', permission_action: 2}),
        // createRoute('/plReactivationPending', 'Reactivation<br>Application ', PagePLReactivation, {permission: 'parkinglicense_reactivation', permission_action: 2}),
      ]),
    ]
  ),

  // createRoute('/parker', 'Parker', false, PageSubscriber, {permission: 'carpark_'}),
  createRoute('/parkinglicenseView', 'Parking License View', false, PagePLView, {permission: 'parkinglicense'}),
  createRoute('/plApplicationForm', 'Parking License Application Form', false, PagePLApplicationForm2, {permission: 'parkinglicense_application'}),
  createRoute('/plAddOnForm', 'Parking License Add On Form', false, PagePLAddOnForm2, {permission: 'parkinglicense_addon'}),
  createRoute('/plTerminationForm', 'Parking License Tremination Form', false, PagePLTerminationForm, {permission: 'parkinglicense_termination'}),
  createRoute('/plReactivationForm', 'Parking License Reactivation Form', false, PagePLReactivationForm, {permission: 'parkinglicense_termination'}),
  createRoute('/plProductChangeForm', 'Parking License Product Change Form', false, PagePLProductChangeForm, {permission: 'parkinglicense_pc'}),
  createRoute('/plPaymentPlanChangeForm', 'Parking License Payment Plan Change Form', false, PagePLPaymentPlanChangeForm, {permission: 'parkinglicense_ppc'}),
  createRoute('/plReinstatementForm', 'Parking License Reinstatement Form', false, PagePLReinstatementForm, {permission: 'parkinglicense_reinstatement'}),

  createRoute('', 'Passcard', 'fa fa-ticket', [
      createRoute('', 'Passcard Inventory', [
        createRoute('/passcardType', 'Passcard Type', PagePasscardType, {permission: 'passcard_type'}),
        createRoute('/passcard', 'All Passcard', PagePasscard, {permission: 'passcard_all'}),
      ]),
      
      createRoute('', 'Passcard Issuance', [
        createRoute('/passcardIssue', 'Pending Passcard<br>Issuance', PagePasscardIssue, {permission: 'passcard_issue', permission_action: 4}),
        createRoute('/passcardIssuePriority', 'Pending Passcard<br>Issuance (Priority)', PagePasscardIssuePriority, {permission: 'passcard_issue', permission_action: 4}),
        createRoute('/passcardIssueLetter', 'Print Passcard<br>Issuance Letter', PagePasscardLetter, {permission: 'passcard_issue', permission_action: 4}),
      ]),
      
      createRoute('', 'Termination', [
        createRoute('/passcardTermination', 'Termination Passcard<br>Return', PagePasscardTermination, {permission: 'passcard_termination_return', permission_action: 2}),
        createRoute('/passcardTerminationApplication', 'Termination Passcard<br>Return Application', PagePasscardTerminationApplication, {permission: 'passcard_termination_return', visible: '.add'}),
      ]),
      createRoute('/passcardTerminationForm', 'Termination Passcard Return Form', false, PagePasscardTerminationForm, {permission: 'passcard_termination_return'}),
      
      createRoute('', 'Lost/Damage/Faulty', [
        createRoute('/passcardLostDamageFaulty', 'Lost/Damage/Faulty<br>Passcard', PagePasscardLostDamageFaulty, {permission: 'passcard_lostdamagafaulty', permission_action: 2}),
        createRoute('/passcardLostDamageFaultyApplication', 'Lost/Damage/Faulty<br>Passcard Application', PagePasscardLostDamageFaultyApplication, {permission: 'passcard_lostdamagafaulty', visible: '.add'}),
      ]),
      createRoute('/passcardLostDamageFaultyForm', 'Lost/Damage/Faulty Passcard Form', false, PagePasscardLostDamageFaultyForm, {permission: 'passcard_lostdamagafaulty'}),
      
      createRoute('', 'Lost and Found', [
        createRoute('/passcardLostAndFound', 'Lost and Found<br>Passcard', PagePasscardLostAndFound, {permission: 'passcard_lostandfound', permission_action: 2}),
        createRoute('/passcardLostAndFoundApplication', 'Lost and Found<br>Passcard Application', PagePasscardLostAndFoundApplication, {permission: 'passcard_lostandfound', visible: '.add'}),
      ]),
      createRoute('/passcardLostAndFoundForm', 'Lost and Found Passcard Form', false, PagePasscardLostAndFoundForm, {permission: 'passcard_lostandfound'}),
      
      createRoute('', 'Passcard to ParkAide', [
        createRoute('/passcardToParkAide', 'Passcard to ParkAide', PagePasscardToParkAide, {permission: 'passcard_toparkaide', permission_action: 2}),
        createRoute('/passcardToParkAideApplication', 'Passcard to ParkAide Application', PagePasscardToParkAideApplication, {permission: 'passcard_toparkaide', visible: '.add'}),
      ]),
      createRoute('/passcardToParkAideForm', 'Passcard to ParkAide Form', false, PagePasscardToParkAideForm, {permission: 'passcard_toparkaide'}),
      
      createRoute('', 'ParkAide To Passcard', [
        createRoute('/passcardFromParkAide', 'ParkAide to Passcard', PagePasscardFromParkaide, {permission: 'passcard_fromparkaide', permission_action: 2}),
        createRoute('/passcardFromParkAideApplication', 'ParkAide to Passcard Application', PagePasscardFromParkaideApplication, {permission: 'passcard_fromparkaide', visible: '.add'}),
      ]),
      createRoute('/passcardFromParkAideForm', 'ParkAide to Passcard Form', false, PagePasscardFromParkaideForm, {permission: 'passcard_fromparkaide'}),
      
      createRoute('', 'Passcard Returned', [
        createRoute('/passcardReturnTermination', 'Termination', PagePasscardReturnTermination, {permission: 'passcard_returned', permission_action: 4}),
        createRoute('/passcardReturnDamageFaulty', 'Damage/Faulty', PagePasscardReturnDamageFaulty, {permission: 'passcard_returned', permission_action: 4}),
        createRoute('/passcardReturnLostAndFound', 'Lost and Found', PagePasscardReturnLostAndFound, {permission: 'passcard_returned', permission_action: 4}),
        createRoute('/passcardReturnToParkAide', 'ParkAide', PagePasscardReturnToParkAide, {permission: 'passcard_returned', permission_action: 4}),
      ]),
      

      createRoute('', 'Block/Un-Block Passcard', [
        createRoute('/passcardBlock', 'Pending Block Passcard', PagePasscardBlock, {permission: 'passcard_pending_block', permission_action: 4}),
        createRoute('/passcardUnblock', 'Pending Un-Block Passcard', PagePasscardUnblock, {permission: 'passcard_pending_unblock', permission_action: 4}),
      ]),

      createRoute('', 'Block/Un-Block Returned Card', [
        createRoute('/passcardBlockTermination', 'Pending Block (Termination)', PagePasscardBlockTermination, {permission: 'passcard_returned_block', permission_action: 4}),
        createRoute('/passcardBlockLostDamageFaulty', 'Pending Block (Lost/Damage/Faulty)', PagePasscardBlockDamageFaulty, {permission: 'passcard_returned_block', permission_action: 4}),
        createRoute('/passcardBlockLostAndFound', 'Pending Block (Lost and Found)', PagePasscardBlockLostAndFound, {permission: 'passcard_returned_block', permission_action: 4}),
        createRoute('/passcardBlockLostParkAide', 'Pending Block (ParkAide)', PagePasscardBlockToParkAide, {permission: 'passcard_returned_block', permission_action: 4}),
        createRoute('/passcardUnblockLostAndFound', 'Pending Un-Block (Lost and Found)', PagePasscardUnblockLostAndFound, {permission: 'passcard_returned_unblock', permission_action: 4}),
      ]),
    ]
  ),
  createRoute('/passcardTerminationApplication2', 'Passcard Return View', false, PagePasscardTerminationApplicationView, {permission: 'passcard_termination_return'}),
  createRoute('/passcardTerminationApplication3', 'Passcard Return Print', false, PagePasscardTerminationApplicationPrint, {permission: 'passcard_termination_return'}),

  createRoute('', 'Refund Management', 'fa fa-share', [
      createRoute('/refundRequest', 'Termination Refund Request List', PageRefundList, {permission: 'termination_refund_request', permission_action: 4}),
      createRoute('/refundVoucher', 'Payment Voucher List', PageRefundVoucher, {permission: 'payment_voucher', permission_action: 4}),
      // createRoute('/refundAll', 'Termination Refund Transaction', PageRefundAll, {permission: 'refund_management', permission_action: 4}),
      createRoute('/pv2', 'Payment Voucher', false, PagePaymentVoucher, {permission: 'payment_voucher'}),
      // createRoute('/refundGenerateGiro', 'Generate Giro File', PageRefundGenerateGiroFile, {permission: 'refund_management', permission_action: 4}),
    ]
  ),
  createRoute('/pv', 'PV', false, PagePV),

  createRoute('', 'Collection', 'fa fa-usd', [
      createRoute('/billCollection', 'Bill Collection', PageBillCollection, {permission: 'collection_bill', permission_action: 4}),
      
      // createRoute('/billTagDepositCheque', 'Tag Deposit (Cheque)', PageTagDepositCheque),
      // createRoute('/billTagDepositCash', 'Tag Deposit (Cash)', PageTagDepositCash),
      // createRoute('/billPPS', 'Perm Payment Schedule (PPS)', PageTagDepositPPS),
      createRoute('', 'Transaction', [
        createRoute('/payHistory', 'Payment History', PagePaymentHistory, {permission: 'collection_transaction', permission_action: 3}),
        createRoute('/officialReceipt', 'Official Receipts', PageOfficialReceipt, {permission: 'collection_receipt', permission_action: 3}),
      ]),
    ]
  ),
  createRoute('/payDetail', 'Payment Detail', false, PagePaymentDetail),
  createRoute('/billPayment', 'Bill Payment', false, PageBillPayment),
  createRoute('/billIpay', 'Bill Payment iPay', false, PageBillIpay88),
  createRoute('/billIpay2', 'Bill Payment iPay 2', false, PageBillIpay88_2),
  createRoute('/billIpay3', 'Bill Payment iPay 3', false, PageBillIpay88_3),
  createRoute('/billOR', 'Official Receipt', false, PageOR),

  createRoute('', 'Bill Management', 'fa fa-folder', [
      createRoute('/billAccount', 'Account Summary', PageBillAccountSummary, {permission: 'bill_management', permission_action: 3}),
      createRoute('/billInvoice', 'Invoice', PageBillInvoice, {permission: 'bill_management_invoice', permission_action: 3}),
      createRoute('/billCN', 'Credit Notes', PageBillCN, {permission: 'bill_management_creditnote', permission_action: 3}),
      createRoute('/billDN', 'Debit Notes', PageBillDN, {permission: 'bill_management_debitenote', permission_action: 3}),
      createRoute('/stopBillRecord', 'Stop Bill Records', PageStopBillRecord, {permission: 'bill_management_stop_bill_record', permission_action: 3}),
      createRoute('/reverseStopBill', 'Reverse Stop Bill', PageReverseStopBill, {permission: 'bill_management_reactivation', permission_action: [{permission: '.view', action: 'View '}, {permission: '.add', action: 'Add '}]}),
      createRoute('/billEInvoiceSetting', 'E-Invoice Setting', PageEInvoiceSetting, {permission: 'bill_management_e_invoice_setting', permission_action: [{permission: '.view', action: 'View '}, {permission: '.add', action: 'Add '}, {permission: '.edit', action: 'Update '}]}),
      createRoute('/billConsolidated', 'Consolidated Bills', PageConsolidatedBill, {permission: 'bill_management_consolidated', permission_action: [{permission: '.view', action: 'View '}]}),
      createRoute('/billEInvoiceDocument', 'E-Invoice Documents', PageEInvoiceDocument, {permission: 'bill_management_e_invoice_document', permission_action: [{permission: '.view', action: 'View '}]}),
    ]
  ),
  createRoute('/billPage', 'InvoiceBill', false, PageBill),
  createRoute('/reverseStopBillForm', 'Reverse Stop Bill Application', false, PageReverseStopBillForm, {permission: 'bill_management_reactivation'}),

  createRoute('', 'Manual Operation', 'fa fa-briefcase', [
    createRoute('', 'Application', [
      // createRoute('/plApplicationForm2', 'Parking License Application (Parker)', PagePLApplicationForm2, {permission: 'secretadmin'}),
      // createRoute('/plAddonForm2', 'Parking License Add-On (Parker)', PagePLAddOnForm2, {permission: 'secretadmin'}),
      createRoute('/plApplicationFormForce', 'Parking License Application (Force)', PagePLApplicationForm2, {permission: 'secretadmin'}),
      createRoute('/plAddOnFormForce', 'Parking License Add-On (Force)', PagePLAddOnForm2, {permission: 'secretadmin'}),
      createRoute('/plTerminationFormForce', 'Parking License Termination (Force)', PagePLTerminationForm, {permission: 'secretadmin'}),
      createRoute('/plProductChangeFormForce', 'Parking License Product Change (Force)', PagePLProductChangeForm, {permission: 'secretadmin'}),
      createRoute('/passcardTerminationApplicationForce', 'Termination Passcard Return (Force)', PagePasscardTerminationApplication, {permission: 'secretadmin'}),
    ]),
    createRoute('', 'Billing', [
      createRoute('/manualBillLicense', 'Monthly Fee Invoice (PL)', PageManualBillLicense, {permission: 'secretadmin'}),
      createRoute('/manualBillCarpark', 'Monthly Fee Invoice (Car Park)', PageManualBillCarpark, {permission: 'secretadmin'}),
      createRoute('/manualRateLicense', 'Rate Change (PL)', PageManualRateLicense, {permission: 'secretadmin'}),
      createRoute('/billCollectionForce', 'Bill Collection (Force)', PageBillCollectionForce, {permission: 'secretadmin'}),
      createRoute('/billCollectionSplit', 'Bill Collection (Split)', PageBillCollectionSplit, {permission: 'secretadmin'}),
      createRoute('/manualBillLatePayment', 'Late Payment (PL)', PageManualLatePayment, {permission: 'secretadmin'}),
      createRoute('/manualBillLatePaymentReverse', 'Late Payment Reverse', PageManualLatePaymentReverse, {permission: 'secretadmin'}),
      createRoute('/manualBillProductChange', 'Product Change (PL)', PageManualProductChange, {permission: 'secretadmin'}),
      createRoute('/manualReachTerminationEffectiveDate', 'Reach 1 Day after Termination Effective Date (PL)', PageManualTerminate, {permission: 'secretadmin'}),
      createRoute('/manualReachTerminationEffectiveDate14', 'Reach 14 Days after Termination Effective Date (PL)', PageManualTerminate14, {permission: 'secretadmin'}),
      createRoute('/manualStopBillEmail', 'Stop Bill (Old)', PageManualStopBillEmail, {permission: 'secretadmin'}),
      createRoute('/manualStopBill', 'Stop Bill', PageManualStopBill, {permission: 'secretadmin'}),
      createRoute('/manualReactivate', 'Reactivate', PageManualReactivate, {permission: 'secretadmin'}),
      
    ]),
    createRoute('', 'Snatch', [
      // createRoute('/manualManualParkaide2', 'Sync to ParkAide', PageManualParkaide2, {permission: 'secretadmin'}),
      // createRoute('/manualManualParkaide', 'Sync to ParkAide', PageManualParkaide, {permission: 'secretadmin'}),
      createRoute('/manualManualSnatch', 'Sync to Snatch', PageManualSnatch, {permission: 'secretadmin'}),
    ]),
    createRoute('/manualProductFees', 'Product Fees Manual', PageProductFeesChange, {permission: 'secretadmin'}),

  ]
),
createRoute('/payDetail', 'Payment Detail', false, PagePaymentDetail),

  createRoute('', 'Adminstration', 'fa fa-cogs', [
      createRoute('', 'People Management', [
        createRoute('/staff', 'Staff List', PageStaff, {permission: 'adminstration'}),
        createRoute('/internalRoleList', 'Roles', PageRole, {permission: 'adminstration_role'}),
        createRoute('/internalUserList', 'Internal User List', PageInternalUser, {permission: 'adminstration_internal_user'}),
        // createRoute('/internalUserRoleList', 'Internal User Roles', PageUserRole, {permission: null}),
      ]),
      createRoute('', 'Parking License Management', [
        createRoute('/plTnC', 'Registration T&C', PageRegistrationTnC, {permission: 'adminstration_tnc', permission_action: 4}),
        createRoute('/plPP', 'Registration Privacy Policy', PageRegistrationPP, {permission: 'adminstration_privacypolicy', permission_action: 4}),
        createRoute('/plTerminationTnC', 'Termination T&C', PageTerminationTnC, {permission: 'adminstration_terminationtnc', permission_action: 4}),
        createRoute('/systemActivityDates', 'System Activity Dates', PageSystemActivityDate, {permission: 'adminstration_date', permission_action: 4}),
      ]),
      createRoute('/userSetting', 'System Configuration', PageSetting, {permission: 'adminstration_configuration', permission_action: 4}),
    ]
  ),
  createRoute('/plTnCview', 'Parking License T&C', false, PageViewTnC, {permission: null}),
  createRoute('/plPPview', 'Parking License PP', false, PageViewPP, {permission: null}),
  createRoute('/plSeasonTerminationTnCview', 'Parking License Termination Product', false, PageViewSeasonTerminationTnC, {permission: null}),
  createRoute('/internalRoleForm', 'Internal User Roles Form', false, PageRoleForm, {permission: 'adminstration_role'}),
  
  createRoute('', 'Report', 'fa fa-file', [
      createRoute('/reportCustomerFees', 'Customer Fees', PageReportCustomerFees, {permission: 'report_customer_fees', permission_action: 3}),
      // createRoute('/reportCustomerMovement', 'Customer Movement', PageReportCustomerMovement, {permission: 'report', permission_action: 3}),
      // createRoute('/reportCarparkProduct', 'Car Park Product ', PageReportCarparkProduct, {permission: 'report', permission_action: 3}),
      // createRoute('/reportCarparkBill', 'Car Park Bill Collection', PageReportBill, {permission: 'report', permission_action: 3}),
      // createRoute('/reportCustomerCompany', 'Car Park Company Customer Status', PageReportCustomerCompany, {permission: 'report', permission_action: 3}),
      // createRoute('/reportCustomerPersonal', 'Car Park Personal Customer Status', PageReportCustomerPersonal, {permission: 'report', permission_action: 3}),
      createRoute('/reportCarparkCollection', 'Car Park Collection', PageReportCarParkCollection, {permission: 'report_carpark_collection', permission_action: 3}),
      createRoute('/reportOutstanding', 'Outstanding Bills', PageReportOutstanding, {permission: 'report_outstanding_bill', permission_action: 3}),
      createRoute('/reportInvoice', 'Invoice Report', PageReportInvoice, {permission: 'report_invoice', permission_action: 3}),
      createRoute('/reportCarparkSST', 'Car Park SST', PageReportCarParkSST, {permission: 'report_carpark_sst', permission_action: 3}),
      createRoute('/reportRemittance', 'Remittance Fees', PageReportRemittance, {permission: 'report_remittance_fee', permission_action: 3}),
      createRoute('/reportPersonal', 'Personal Profile', PageReportProfilePersonal, {permission: 'report_personal_profile', permission_action: 3}),
      createRoute('/reportCompany', 'Company Profile', PageReportProfileCompany, {permission: 'report_company_profile', permission_action: 3}),
      createRoute('/reportSubscription', 'Subscription', PagePLLeaseReport, {permission: 'report_subscription', permission_action: 3}),
      createRoute('/reportLPR', 'LPR', PageReportLPR, {permission: 'report_lpr', permission_action: 3}),
    ]
  ),

  createRoute('/logout', 'Logout', 'fa fa-power-off', PageLogout),

  
  createRoute('/login', 'Login', false, PageLogin),
  createRoute('/register', 'Register', false, PageRegister),
  createRoute('/verifyRegister', 'Verify', false, PageVerify),
  createRoute('/forgotPassword', 'Forgot Password', false, PageForgotPassword),
  createRoute('/verify', 'Change Password', false, PageChangePassword),
  createRoute('/redirect', 'Redirect', false, PageRedirect),
  createRoute('/initial', 'Initial', false, PageNoProfile),
  createRoute('/termsAndConditions', 'Terms And Conditions', false, PageTnc),
  createRoute('/privacyPolicy', 'Privacy Policy', false, PagePrivacyPolicy),
  createRoute('/chooseAccount', 'Choose Account', false, PageChooseAccount),
  createRoute('/createProfile', 'Create Profile', false, PageCreateProfile),
  createRoute('/account', 'Account', false, PageAccount),
]

/*
// TODO somewhat not working on server
// Syntax Error: Unexpected token (38:56)
// > 38 |   createRoute('/', 'Dashboard', 'fa fa-th-large', () => import('@/components/Page/PageDashboard')),
//      |                                                         ^
const routeAll = [
  createRoute('/', 'Dashboard', 'fa fa-th-large', () => import('@/components/Page/PageDashboard')),
  createRoute('/city', 'City', 'fa fa-building', () => import('@/components/Page/PageCity')),
  createRoute('', 'Car Park', 'fa fa-car', [
      createRoute('/entitlement', 'Entitlement', () => import('@/components/Page/PageEntitlement')),
      createRoute('/carpark', 'Car Park', () => import('@/components/Page/PageCarPark')),
      createRoute('/level', 'Car Park Level', () => import('@/components/Page/PageLevel')),
      createRoute('', 'Car Park Zone', [
        createRoute('/test1', 'Zone', () => import('@/components/Page/PageZone')),
        createRoute('/test2', 'Zone Level', PageTest),
        createRoute('/street', 'Street', () => import('@/components/Page/PageStreet')),
        createRoute('/bay', 'Bay', () => import('@/components/Page/PageStreetBay')),
      ]),
      createRoute('/product', 'Car Park Product', () => import('@/components/Page/PageProduct')),
      createRoute('/test6', 'Car Park Tenant', PageTest),
    ]
  ),
  createRoute('', 'Parking License', 'fa fa-id-card-o', [
      createRoute('', 'Customer List', [
        createRoute('/company', 'Company', () => import('@/components/Page/PageCompany')),
        createRoute('/personal', 'Personal', () => import('@/components/Page/PagePersonal')),
      ]),
      createRoute('', 'Parking License', [
        createRoute('/test9', 'PL by Car Park', PageTest),
        createRoute('/test0', 'PL by Account Holder', PageTest),
        createRoute('/test11', 'Subscription by Car Park', PageTest),
        createRoute('/test12', 'Subscription by Account Holder', PageTest),
      ]),
      createRoute('', 'Application', [
        createRoute('/test13', 'Parking License\nApplication', PageTest),
        createRoute('/test14', 'Parking License\nTermination', PageTest),
      ]),
    ]
  ),
  createRoute('', 'Passcard', 'fa fa-ticket', [
      createRoute('', 'Passcard Inventory', [
        createRoute('/test15', 'Passcard type', PageTest),
        createRoute('/test16', 'All Passcard', PageTest),
      ]),
    ]
  ),
  createRoute('', 'Collection', 'fa fa-', [
      createRoute('/test17', 'Bill Collection', PageTest),
    ]
  ),
  createRoute('', 'Adminstration', 'fa fa-cogs', [
      createRoute('', 'User Management', [
        createRoute('/test18', 'Staff List', PageTest),
      ]),
    ]
  ),

  createRoute('/logout', 'Logout', 'fa fa-power-off', () => import('@/components/Page/User/PageLogout')),

  createRoute('/login', 'Login', false, () => import('@/components/Page/User/PageLogin')),
  createRoute('/carparkForm', 'Car Park Form', false, () => import('@/components/Page/PageCarParkForm')),
  createRoute('/productForm', 'Product Form', false, () => import('@/components/Page/PageProductForm')),
  createRoute('/productFees', 'Product Fees', false, () => import('@/components/Page/PageProductFees')),
  createRoute('/companyForm', 'Company Form', false, () => import('@/components/Page/PageCompanyForm')),
  createRoute('/personalForm', 'Personal Form', false, () => import('@/components/Page/PagePersonalForm')),
]
*/



// add route to vue router
let routeList = function traverseRoute(routeList, routeItem, routeParent, routeSection) {
  for(var routeIndex in routeItem) {
    let routeObject = routeItem[routeIndex];
    routeObject['parent'] = routeParent;
    routeObject['section'] = routeSection || routeObject.name;

    if(routeObject.child && routeObject.child.length > 0) {
      traverseRoute(routeList, routeObject.child, routeObject.name, routeParent === null ? routeObject.name : routeSection);
    }

    if(routeObject.path) {
      // var temp = {};
      // temp.path = routeObject.path;
      // temp.name = routeObject.name;
      // temp.component = routeObject.component;
      routeObject.path = helper.WEB_URL ? helper.WEB_URL + routeObject.path : routeObject.path;
      // routeObject.path = routeObject.path;
      routeList.push(routeObject);
    }
  }

  return routeList;
}([], routeAll, null);

// init vue router
let router = new Router({
  mode: 'history',
  routes: routeList,
});

let checkParkerProfile = function(to, from, next, lastPath) {
  if(helper.checkRoleIsParker()) {
    if(!helper.checkRoleHasCustomerID()) {
    // if(false) {
      // no profile, only allow access to company/company form/personal/personal form
      if(lastPath == 'landing'
      || lastPath == 'personal'
      || lastPath == 'personalForm'
      || lastPath == 'company'
      || lastPath == 'companyForm'
      ) {
        next();
      } else {
        next({ path: helper.WEB_URL + '/personalForm'});
        // next({ path: helper.WEB_URL + '/createProfile'});
      }
      // if(helper.checkRoleIsCompany()) {
      //   if(lastPath == 'company'
      //     || lastPath == 'companyForm'
      //     // || lastPath == 'createProfile'
      //   ) {
      //     next();
      //   } else {
      //     next({ path: helper.WEB_URL + '/companyForm'});
      //     // next({ path: helper.WEB_URL + '/createProfile'});
      //   }
      // } else {
      //   if(lastPath == 'personal'
      //     || lastPath == 'personalForm'
      //     // || lastPath == 'createProfile'
      //   ) {
      //     next();
      //   } else {
      //     next({ path: helper.WEB_URL + '/personalForm'});
      //     // next({ path: helper.WEB_URL + '/createProfile'});
      //   }
      // }
    } else {
      // TODO allow all page to be access first
      next();
      return;
      // has profile, only allow particular pages
      if(lastPath == 'landing'
        || lastPath == 'company'
        || lastPath == 'companyForm'
        || lastPath == 'personal'
        || lastPath == 'personalForm'
        || lastPath == 'companyParker'
        || lastPath == 'personalParker'
        || lastPath == 'parkinglicense'
        || lastPath == 'parkinglicenseView'
        || lastPath == 'plLease'
        || lastPath == 'plParkAideLease'
        || lastPath == 'plApplication'
        || lastPath == 'plApplicationForm'
        || lastPath == 'plAddOn'
        || lastPath == 'refundVoucher'
        || lastPath == 'pv2'
      ) {
        next();
      } else {
        next({ path: helper.WEB_URL + '/personal'});
        // if(helper.checkRoleIsCompany()) {
        //   next({ path: helper.WEB_URL + '/company'});
        // } else {
        //   next({ path: helper.WEB_URL + '/personal'});
        // }
      }
    }
    return;
  }

  next();
}

// redirect based on login
router.beforeEach((to, from, next) => {
  let lastPath = to.path.replace(/^\/|\/$/g, '').split('/').slice(-1)[0];
  if(lastPath == 'redirect'
    || lastPath == 'verify'
    || lastPath == 'termsAndConditions'
    || lastPath == 'privacyPolicy'
    || lastPath == 'logout'
  ) {
    next();
  } else if(lastPath == 'billIpay'
    || lastPath == 'billIpay2') {
    next();
  } else if(lastPath == 'account'
    || lastPath == 'chooseAccount') {
    if(localStorage.getItem('user')) {
      next();
    } else {
      next({ path: helper.WEB_URL + '/login'});
    }
  } else if(lastPath == 'login'
    || lastPath == 'register' 
    || lastPath == 'verifyRegister' 
    || lastPath == 'forgotPassword'
    || lastPath == 'changePassword'
    ) {
    if(localStorage.getItem('user')) {
      next({ path: helper.WEB_URL + '/'});
    } else {
      next();
    }
  } else {
    if(localStorage.getItem('user')) {
      checkParkerProfile(to, from, next, lastPath);
    } else {
      next({ path: helper.WEB_URL + '/login'});
    }
  }

  // let user = JSON.parse(localStorage.getItem('user'))
  if(to.matched.some(record => record.meta.is_admin)) {}

  // if(localStorage.getItem('user')) {
  //   next({
  //       path: '/login',
  //       params: { nextUrl: to.fullPath }
  //   })
  // } else {
  //   next({
  //       path: '/carpark',
  //       params: { nextUrl: to.fullPath }
  //   })
  // }
})

export default {
  router: router,
  routeAll: routeAll,
  routeList: routeList,
}



// WEBPACK FOOTER //
// ./src/router/index.js